import type {
  ExtensionApi,
  ExtensionInitiateResponse,
  ExtensionSessionResponse,
} from "@/features/extension/contracts";
import { httpClient } from "@/shared/api/httpClient";

export const realExtensionApi: ExtensionApi = {
  // POST with no body - httpClient already treats null/undefined identically
  // (no body, no Content-Type) so express body-parser doesn't choke on a
  // top-level "null" literal (guide §9 last bullet).
  async initiate(): Promise<ExtensionInitiateResponse> {
    return httpClient.post<ExtensionInitiateResponse>("/api/extension/handshake/initiate");
  },

  async getSession(): Promise<ExtensionSessionResponse> {
    return httpClient.get<ExtensionSessionResponse>("/api/extension/session");
  },
};
